<template>
    <div>
         <nav-bar-main  v-if="$store.state.userLastPlants.length >0"></nav-bar-main>
         <Loader />  
         <div v-if="userDetails!=null" class="animated fadeIn mt-3">
            
            <!-- titolo profile --> 
            <b-row >                 
                <b-col cols="6">
                    <div id="title-first" class="ml-5 mt-2 typo-label">
                        <i class="fa fa-user pr-1 pt-1 fa-1x pull-left"></i>
                        <span>{{$t("userProfile.title")}}: <b>{{$t("userProfile.data")}}</b></span>
                    </div>
                </b-col>
            </b-row>

            <!-- card user info --> 
            <b-row >   
               <b-col md="10" sm="12" id="sezione-profilo">
                <!-- Visualizza dati del profilo -->
                <b-card id="card-view" v-if="!editMode && !editMarketingMode && this.$route.params.event!='InstallerReg' && this.$route.params.event!='InstallerRegFirst'" class="mx-5 mt-2 radius-card card-profile">
                   <div class="mb-3"><b><span class="bold-18">{{currentUser.name}} {{currentUser.surname}}</span></b></div>
                   <avatar   
                       :username="currentUser.name + ' ' + currentUser.surname"
                       background-color="#04709C"
                       :size="60"
                       :rounded="true"
                       color="#FFFFFF"
                       class="p-4 mr-3 mt-3"
                       style="display:inline"
                   ></avatar>
                   <div style="display: inline-block">
                       <div><b>{{currentUser.email}}</b></div>
                       <div>{{$t("userProfile."+currentUser.usertype)}}</div>
                   </div>  
                   <div v-if="currentUser.usertype=='installer' || currentUser.usertype=='client'">  
                        <div v-if="currentUser.businessname && currentUser.businessname!='null'" class="mb-1 mt-5"><b><span class="typo-title" >{{currentUser.businessname}}</span></b></div>
                        <div class="mb-1 mt-2">{{currentUser.street}}, {{currentUser.housenumber}}</div>
                        <div class="mb-1 mt-1">{{currentUser.city}} ({{currentUser.prov}}) {{currentUser.country}}</div>
                        <div class="mb-1 mt-1">{{$t("userProfile.phone")}}: {{currentUser.phone}}</div> 
                        <div v-if="currentUser.piva && currentUser.piva!='null'"  class="mb-4 mt-1">{{$t("userProfile.piva")}}: {{currentUser.piva}}</div> 
                        <b-row>
                            <b-col cols="6">    
                                <b-button variant="link" @click="editProfile()" class="mt-2">
                                    <img class="mr-1 editIcon" src="/img/editPen.svg">
                                    <span class="editText">{{$t("userProfile.edit")}}</span>
                                </b-button>
                            </b-col>
                            <b-col cols="6">    
                                <b-button variant="link" @click="editMarketing()" class="mt-2 float-right">
                                    <img class="mr-1 editIcon" src="/img/editPen.svg">
                                    <span class="editText">{{$t("userProfile.editMarketing")}}</span>
                                </b-button>
                                <b-button variant="link" class="mt-2 float-right">
                                    <a :href="$t('link.privacy_policy_registration')"  target="_blank">Privacy Policy</a>
                                </b-button>    
                            </b-col>
                        </b-row>        
                    </div>  
                    <div v-if="currentUser.usertype=='basic'">  
                        <div class="mt-3">{{$t('userProfile.installerTitle')}} </div>
                        <label class="mt-2">{{$t('userProfile.installerIntro')}}</label>
                        <p class="lead mt-3">
                            <b-button @click="installerFromProfile()" class="bg-primary noborder btn-pill p-2"><span class="px-5 text-pill">{{$t('home.register_as_installer')}}</span></b-button>
                        </p>
                        <b-row>
                            <b-col cols="6">    
                            </b-col>
                            <b-col cols="6">    
                                <b-button variant="link" @click="editMarketing()" class="mt-2 float-right">
                                    <img class="mr-1 editIcon" src="/img/editPen.svg">
                                    <span class="editText">{{$t("userProfile.editMarketing")}}</span>
                                </b-button>
                                <b-button variant="link" class="mt-2 float-right">
                                    <a :href="$t('link.privacy_policy_registration')">Privacy Policy</a>
                                </b-button>    
                            </b-col>
                        </b-row>     
                    </div>    
               </b-card>   

               <!-- Modifica dati del profilo -->
                <b-card id="card-edit" v-if="editMode || this.$route.params.event=='InstallerReg' || this.$route.params.event=='InstallerRegFirst'" class="mx-5 mt-2 radius-card card-profile">
                   <div v-if="this.$route.params.event!='InstallerReg' && this.$route.params.event!='InstallerRegFirst'" class="mb-3"><b><span class="bold-18">{{$t("userProfile.editInfo")}}</span></b></div>
                   <div v-if="this.$route.params.event=='InstallerReg' || this.$route.params.event=='InstallerRegFirst'" class="mb-3"><b><span class="bold-18">{{$t("userProfile.installerReg")}}</span></b></div>
                   <avatar v-if="this.$route.params.event!='InstallerReg' && this.$route.params.event!='InstallerRegFirst'"  
                       :username="currentUser.name + ' ' + currentUser.surname"
                       background-color="#04709C"
                       :size="60"
                       :rounded="true"
                       color="#FFFFFF"
                       class="p-4 mr-3 mt-3"
                       style="display:inline"
                   ></avatar>
                   <div v-if="this.$route.params.event!='InstallerReg' && this.$route.params.event!='InstallerRegFirst'" style="display: inline-block">
                       <div><b>{{currentUser.email}}</b></div>
                       <div>{{$t("userProfile."+currentUser.usertype)}}</div>
                   </div>    
                       <div v-if="this.$route.params.event=='InstallerReg' || this.$route.params.event=='InstallerRegFirst'" style="display: inline-block">
                       <div>{{$t("userProfile.installerTitle")}}</div>
                       <div>{{$t("userProfile.installerIntro")}}</div>
                   </div>    

                   <!-- Name and surname -->
                    <b-row>
                        <b-col lg="4" md="6" sm="12" class="mt-3">
                            <b-form-group>
                                <label for="label-user-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                                <b-form-input v-model="userName" class="bold-15" type="text" :state="validation_userName" id="placeholder-user-name" :placeholder="$t('user_modal.placeholder_name')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>        
                        <b-col lg="4" md="6" sm="12" class="mt-3">
                            <b-form-group>
                                <label for="label-user-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                                <b-form-input v-model="userSurname" class="bold-15" type="text" :state="validation_userSurname" id="placeholder-user-surname" :placeholder="$t('user_modal.placeholder_surname')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userSurname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>          
  
                  <!-- Azienda e Piva -->  
                    <b-row v-if="this.currentUser.usertype!='client' || this.$route.params.event=='InstallerReg' || this.$route.params.event=='InstallerRegFirst' || (this.currentUser.piva!='null' && this.currentUser.businessname!='null')">
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                                <b-form-input v-model="userbusinessName" class="bold-15" type="text" :state="validation_userbusinessName" id="placeholder-user-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>    
                       <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                                <b-form-input v-model="userPiva" class="bold-15" type="text" :state="validation_userPiva" id="placeholder-user-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                 <!-- Telefono -->    
                    <b-row>
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                                <b-form-input v-model="userPhone" type="text" class="bold-15" :state="validation_userPhone" id="placeholder-user-phone" :placeholder="$t('user_modal.placeholder_phone')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userPhone">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                             </b-form-group>
                        </b-col>
                    </b-row>          
    
                <!-- Indirizzo -->    
                  <b-row>
                       <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                                <b-form-input v-model="userStreet" type="text" class="bold-15" :state="validation_userStreet" id="placeholder-user-street" :placeholder="$t('user_modal.placeholder_street')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="6" sm="12">
                             <b-form-group>
                                <label for="label-user-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                                <b-form-input v-model="userNumber" type="text" class="bold-15" :state="validation_userNumber" id="placeholder-user-number" :placeholder="$t('user_modal.placeholder_number')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                             </b-form-group>
                        </b-col>
                  </b-row>
     
                  <b-row>
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                                <b-form-input v-model="userCity" type="text" class="bold-15" :state="validation_userCity" id="placeholder-user-city" :placeholder="$t('user_modal.placeholder_city')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                                <b-form-input v-model="userCap" type="text" class="bold-15" :state="validation_userCap" id="placeholder-user-cap" :placeholder="$t('user_modal.placeholder_cap')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                  </b-row>

                  <b-row>
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                                <b-form-input v-model="userProv" type="text" class="bold-15" :state="validation_userProv" id="placeholder-user-prov" :placeholder="$t('user_modal.placeholder_prov')"></b-form-input>
                                <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="6" sm="12">
                            <b-form-group>
                                <label for="label-user-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                                <b-form-select v-model="userCountry" class="bold-15" :country="country">
                                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>        
                                    <option value="AF">Afghanistan</option>
                                    <option value="AX">Åland Islands</option>
                                    <option value="AL">Albania</option>
                                    <option value="DZ">Algeria</option>
                                    <option value="AS">American Samoa</option>
                                    <option value="AD">Andorra</option>
                                    <option value="AO">Angola</option>
                                    <option value="AI">Anguilla</option>
                                    <option value="AQ">Antarctica</option>
                                    <option value="AG">Antigua and Barbuda</option>
                                    <option value="AR">Argentina</option>
                                    <option value="AM">Armenia</option>
                                    <option value="AW">Aruba</option>
                                    <option value="AU">Australia</option>
                                    <option value="AT">Austria</option>
                                    <option value="AZ">Azerbaijan</option>
                                    <option value="BS">Bahamas</option>
                                    <option value="BH">Bahrain</option>
                                    <option value="BD">Bangladesh</option>
                                    <option value="BB">Barbados</option>
                                    <option value="BY">Belarus</option>
                                    <option value="BE">Belgium</option>
                                    <option value="BZ">Belize</option>
                                    <option value="BJ">Benin</option>
                                    <option value="BM">Bermuda</option>
                                    <option value="BT">Bhutan</option>
                                    <option value="BO">Bolivia, Plurinational State of</option>
                                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                                    <option value="BA">Bosnia and Herzegovina</option>
                                    <option value="BW">Botswana</option>
                                    <option value="BV">Bouvet Island</option>
                                    <option value="BR">Brazil</option>
                                    <option value="IO">British Indian Ocean Territory</option>
                                    <option value="BN">Brunei Darussalam</option>
                                    <option value="BG">Bulgaria</option>
                                    <option value="BF">Burkina Faso</option>
                                    <option value="BI">Burundi</option>
                                    <option value="KH">Cambodia</option>
                                    <option value="CM">Cameroon</option>
                                    <option value="CA">Canada</option>
                                    <option value="CV">Cape Verde</option>
                                    <option value="KY">Cayman Islands</option>
                                    <option value="CF">Central African Republic</option>
                                    <option value="TD">Chad</option>
                                    <option value="CL">Chile</option>
                                    <option value="CN">China</option>
                                    <option value="CX">Christmas Island</option>
                                    <option value="CC">Cocos (Keeling) Islands</option>
                                    <option value="CO">Colombia</option>
                                    <option value="KM">Comoros</option>
                                    <option value="CG">Congo</option>
                                    <option value="CD">Congo, the Democratic Republic of the</option>
                                    <option value="CK">Cook Islands</option>
                                    <option value="CR">Costa Rica</option>
                                    <option value="CI">Côte d'Ivoire</option>
                                    <option value="HR">Croatia</option>
                                    <option value="CU">Cuba</option>
                                    <option value="CW">Curaçao</option>
                                    <option value="CY">Cyprus</option>
                                    <option value="CZ">Czech Republic</option>
                                    <option value="DK">Denmark</option>
                                    <option value="DJ">Djibouti</option>
                                    <option value="DM">Dominica</option>
                                    <option value="DO">Dominican Republic</option>
                                    <option value="EC">Ecuador</option>
                                    <option value="EG">Egypt</option>
                                    <option value="SV">El Salvador</option>
                                    <option value="GQ">Equatorial Guinea</option>
                                    <option value="ER">Eritrea</option>
                                    <option value="EE">Estonia</option>
                                    <option value="ET">Ethiopia</option>
                                    <option value="FK">Falkland Islands (Malvinas)</option>
                                    <option value="FO">Faroe Islands</option>
                                    <option value="FJ">Fiji</option>
                                    <option value="FI">Finland</option>
                                    <option value="FR">France</option>
                                    <option value="GF">French Guiana</option>
                                    <option value="PF">French Polynesia</option>
                                    <option value="TF">French Southern Territories</option>
                                    <option value="GA">Gabon</option>
                                    <option value="GM">Gambia</option>
                                    <option value="GE">Georgia</option>
                                    <option value="DE">Germany</option>
                                    <option value="GH">Ghana</option>
                                    <option value="GI">Gibraltar</option>
                                    <option value="GR">Greece</option>
                                    <option value="GL">Greenland</option>
                                    <option value="GD">Grenada</option>
                                    <option value="GP">Guadeloupe</option>
                                    <option value="GU">Guam</option>
                                    <option value="GT">Guatemala</option>
                                    <option value="GG">Guernsey</option>
                                    <option value="GN">Guinea</option>
                                    <option value="GW">Guinea-Bissau</option>
                                    <option value="GY">Guyana</option>
                                    <option value="HT">Haiti</option>
                                    <option value="HM">Heard Island and McDonald Islands</option>
                                    <option value="VA">Holy See (Vatican City State)</option>
                                    <option value="HN">Honduras</option>
                                    <option value="HK">Hong Kong</option>
                                    <option value="HU">Hungary</option>
                                    <option value="IS">Iceland</option>
                                    <option value="IN">India</option>
                                    <option value="ID">Indonesia</option>
                                    <option value="IR">Iran, Islamic Republic of</option>
                                    <option value="IQ">Iraq</option>
                                    <option value="IE">Ireland</option>
                                    <option value="IM">Isle of Man</option>
                                    <option value="IL">Israel</option>
                                    <option value="IT">Italy</option>
                                    <option value="JM">Jamaica</option>
                                    <option value="JP">Japan</option>
                                    <option value="JE">Jersey</option>
                                    <option value="JO">Jordan</option>
                                    <option value="KZ">Kazakhstan</option>
                                    <option value="KE">Kenya</option>
                                    <option value="KI">Kiribati</option>
                                    <option value="KP">Korea, Democratic People's Republic of</option>
                                    <option value="KR">Korea, Republic of</option>
                                    <option value="KW">Kuwait</option>
                                    <option value="KG">Kyrgyzstan</option>
                                    <option value="LA">Lao People's Democratic Republic</option>
                                    <option value="LV">Latvia</option>
                                    <option value="LB">Lebanon</option>
                                    <option value="LS">Lesotho</option>
                                    <option value="LR">Liberia</option>
                                    <option value="LY">Libya</option>
                                    <option value="LI">Liechtenstein</option>
                                    <option value="LT">Lithuania</option>
                                    <option value="LU">Luxembourg</option>
                                    <option value="MO">Macao</option>
                                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                                    <option value="MG">Madagascar</option>
                                    <option value="MW">Malawi</option>
                                    <option value="MY">Malaysia</option>
                                    <option value="MV">Maldives</option>
                                    <option value="ML">Mali</option>
                                    <option value="MT">Malta</option>
                                    <option value="MH">Marshall Islands</option>
                                    <option value="MQ">Martinique</option>
                                    <option value="MR">Mauritania</option>
                                    <option value="MU">Mauritius</option>
                                    <option value="YT">Mayotte</option>
                                    <option value="MX">Mexico</option>
                                    <option value="FM">Micronesia, Federated States of</option>
                                    <option value="MD">Moldova, Republic of</option>
                                    <option value="MC">Monaco</option>
                                    <option value="MN">Mongolia</option>
                                    <option value="ME">Montenegro</option>
                                    <option value="MS">Montserrat</option>
                                    <option value="MA">Morocco</option>
                                    <option value="MZ">Mozambique</option>
                                    <option value="MM">Myanmar</option>
                                    <option value="NA">Namibia</option>
                                    <option value="NR">Nauru</option>
                                    <option value="NP">Nepal</option>
                                    <option value="NL">Netherlands</option>
                                    <option value="NC">New Caledonia</option>
                                    <option value="NZ">New Zealand</option>
                                    <option value="NI">Nicaragua</option>
                                    <option value="NE">Niger</option>
                                    <option value="NG">Nigeria</option>
                                    <option value="NU">Niue</option>
                                    <option value="NF">Norfolk Island</option>
                                    <option value="MP">Northern Mariana Islands</option>
                                    <option value="NO">Norway</option>
                                    <option value="OM">Oman</option>
                                    <option value="PK">Pakistan</option>
                                    <option value="PW">Palau</option>
                                    <option value="PS">Palestinian Territory, Occupied</option>
                                    <option value="PA">Panama</option>
                                    <option value="PG">Papua New Guinea</option>
                                    <option value="PY">Paraguay</option>
                                    <option value="PE">Peru</option>
                                    <option value="PH">Philippines</option>
                                    <option value="PN">Pitcairn</option>
                                    <option value="PL">Poland</option>
                                    <option value="PT">Portugal</option>
                                    <option value="PR">Puerto Rico</option>
                                    <option value="QA">Qatar</option>
                                    <option value="RE">Réunion</option>
                                    <option value="RO">Romania</option>
                                    <option value="RU">Russian Federation</option>
                                    <option value="RW">Rwanda</option>
                                    <option value="BL">Saint Barthélemy</option>
                                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                                    <option value="KN">Saint Kitts and Nevis</option>
                                    <option value="LC">Saint Lucia</option>
                                    <option value="MF">Saint Martin (French part)</option>
                                    <option value="PM">Saint Pierre and Miquelon</option>
                                    <option value="VC">Saint Vincent and the Grenadines</option>
                                    <option value="WS">Samoa</option>
                                    <option value="SM">San Marino</option>
                                    <option value="ST">Sao Tome and Principe</option>
                                    <option value="SA">Saudi Arabia</option>
                                    <option value="SN">Senegal</option>
                                    <option value="RS">Serbia</option>
                                    <option value="SC">Seychelles</option>
                                    <option value="SL">Sierra Leone</option>
                                    <option value="SG">Singapore</option>
                                    <option value="SX">Sint Maarten (Dutch part)</option>
                                    <option value="SK">Slovakia</option>
                                    <option value="SI">Slovenia</option>
                                    <option value="SB">Solomon Islands</option>
                                    <option value="SO">Somalia</option>
                                    <option value="ZA">South Africa</option>
                                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                                    <option value="SS">South Sudan</option>
                                    <option value="ES">Spain</option>
                                    <option value="LK">Sri Lanka</option>
                                    <option value="SD">Sudan</option>
                                    <option value="SR">Suriname</option>
                                    <option value="SJ">Svalbard and Jan Mayen</option>
                                    <option value="SZ">Swaziland</option>
                                    <option value="SE">Sweden</option>
                                    <option value="CH">Switzerland</option>
                                    <option value="SY">Syrian Arab Republic</option>
                                    <option value="TW">Taiwan, Province of China</option>
                                    <option value="TJ">Tajikistan</option>
                                    <option value="TZ">Tanzania, United Republic of</option>
                                    <option value="TH">Thailand</option>
                                    <option value="TL">Timor-Leste</option>
                                    <option value="TG">Togo</option>
                                    <option value="TK">Tokelau</option>
                                    <option value="TO">Tonga</option>
                                    <option value="TT">Trinidad and Tobago</option>
                                    <option value="TN">Tunisia</option>
                                    <option value="TR">Turkey</option>
                                    <option value="TM">Turkmenistan</option>
                                    <option value="TC">Turks and Caicos Islands</option>
                                    <option value="TV">Tuvalu</option>
                                    <option value="UG">Uganda</option>
                                    <option value="UA">Ukraine</option>
                                    <option value="AE">United Arab Emirates</option>
                                    <option value="GB">United Kingdom</option>
                                    <option value="US">United States</option>
                                    <option value="UM">United States Minor Outlying Islands</option>
                                    <option value="UY">Uruguay</option>
                                    <option value="UZ">Uzbekistan</option>
                                    <option value="VU">Vanuatu</option>
                                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                                    <option value="VN">Viet Nam</option>
                                    <option value="VG">Virgin Islands, British</option>
                                    <option value="VI">Virgin Islands, U.S.</option>
                                    <option value="WF">Wallis and Futuna</option>
                                    <option value="EH">Western Sahara</option>
                                    <option value="YE">Yemen</option>
                                    <option value="ZM">Zambia</option>
                                    <option value="ZW">Zimbabwe</option>
                                </b-form-select> 
                            </b-form-group>  
                         </b-col>
                    </b-row>

                    <div class="d-flex mb-4 mt-5">      
                        <b-button pill @click="saveProfile" variant="primary" class="px-4 save-pill mr-1">{{this.$t("userProfile.save")}}</b-button>
                        <b-button pill @click="cancelEdit" class="px-4 cancel-pill">{{this.$t("userProfile.cancel")}}</b-button>
                    </div>  
               </b-card>      

               <!-- Modifica consensi marketing -->
               <b-card id="card-marketing" v-if="editMarketingMode" class="mx-5 mt-2 radius-card card-profile">
                    <div class="mb-3"><b><span class="bold-18">{{$t("userProfile.editMarketing")}}</span></b></div>
                   <avatar v-if="this.$route.params.event!='InstallerReg' && this.$route.params.event!='InstallerRegFirst'"  
                       :username="currentUser.name + ' ' + currentUser.surname"
                       background-color="#04709C"
                       :size="60"
                       :rounded="true"
                       color="#FFFFFF"
                       class="p-4 mr-3 mt-3"
                       style="display:inline"
                   ></avatar>
                   <div style="display: inline-block">
                       <div><b>{{currentUser.email}}</b></div>
                       <div>{{$t("userProfile."+currentUser.usertype)}}</div>
                   </div>
                   <div>
                        <input type="checkbox" id="chk-marketing" v-model="chk_marketing">
                        <label id="check-marketing" for="checkbox" class="ml-1 mt-4">{{$t("check_marketing")}}<a :href="$t('link.marketing_diretto')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                    </div>
                    <div>    
                        <input type="checkbox" id="chk-profile" v-model="chk_profiling">
                        <label id="check-profiling" for="checkbox" class="ml-1">{{$t("check_profiling")}}<a :href="$t('link.marketing_profilazione')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                    </div>
                    <div>
                       <input type="checkbox" id="chk-comunication" v-model="chk_thirdParts">
                        <label id="check-thirdparts" for="checkbox" class="ml-1">{{$t("check_third_parts")}}<a :href="$t('link.marketing_terzi')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                    </div>    
                    <div class="d-flex mb-4 mt-5">      
                        <b-button pill @click="saveMarketing" variant="primary" class="px-4 save-pill mr-1">{{this.$t("userProfile.save")}}</b-button>
                        <b-button pill @click="cancelMarketing" class="px-4 cancel-pill">{{this.$t("userProfile.cancel")}}</b-button>
                    </div>
               </b-card>
               </b-col>  
            </b-row>
       
         </div>
  </div>
</template>


<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import AccettazioneNominaITA from '@/locales/AccettazioneNominaITA';
import AccettazioneNominaENG from '@/locales/AccettazioneNominaENG'
import Avatar from 'vue-avatar';
import { mapState } from 'vuex';

export default {
    name: 'UserProfile',
    components: {
        NavBarMain,
        Avatar,
        AccettazioneNominaITA,
        AccettazioneNominaENG
    },
    data() {
        return {
            currentUser:"",
            editMode:false,
            editMarketingMode:false,
            userName: '',
            userSurname:'',
            userbusinessName:'',
            userPiva:'',
            userPhone:'',
            userStreet:'',
            userNumber:'',
            userCity:'',
            userCap:'',
            userProv:'',
            userCountry:'IT',
            chk_marketing:false,
            chk_profiling:false,
            chk_thirdParts:false,
            country: null,
            saveUser:false,
            items:[
                {
                    mailInvitato: '',
                    roleInvitato: null
                }
                ],
            options: [
                { value: 'a', text: 'This is First option' }
            ],  
          }
    },
    computed: {
        ...mapState(['commandResponse','error']),
        userDetails() {
           if(this.$store.state.user==null) return;
           this.currentUser=this.$store.state.user;
           console.log("CURRENT USER DATA: ", this.currentUser);
           return this.currentUser;
        },
        validation_userName() {
            if(this.saveUser==true) return (this.userName.length > 0 && /^((?![_./]).)*$/.test(this.name));
         },
        validation_userSurname() {
                if(this.saveUser==true) return (this.userSurname.length > 0 && /^((?![_./]).)*$/.test(this.surname));
            },
        validation_userbusinessName() {
                if(this.saveUser==true) return (this.userbusinessName.length > 0 && /^((?![_./]).)*$/.test(this.surname));
            },
        validation_userStreet() {
                if(this.saveUser==true) return this.userStreet.length > 0
            },
        validation_userPiva() {
                if(this.saveUser==true) return this.userPiva.length > 7 && this.userPiva.length < 13
            },
        validation_userPhone() {
                if(this.saveUser==true) return this.userPhone.length > 0
            },
        validation_userNumber() {
                if(this.saveUser==true) return this.userNumber.length > 0
            },
        validation_userCity() {
                if(this.saveUser==true) return this.userCity.length > 0
            },  
        validation_userCap() {
                if(this.saveUser==true) return this.userCap.length > 0
            },   
        validation_userProv() {
                if(this.saveUser==true) return this.userProv.length > 0
            },    
        validation_userCountry() {
                if(this.saveUser==true) return this.userCountry.length > 0
            }
    },  
    mounted() {
            if(this.$route.params.event=="InstallerReg" || this.$route.params.event=='InstallerRegFirst') 
            {
              this.editMode=true;
              this.userName=this.currentUser.name;
              this.userSurname=this.currentUser.surname;
              if(this.currentUser.phone)  this.userPhone=this.currentUser.phone;
              if(this.currentUser.businessname)  this.userbusinessName=this.currentUser.businessname;
              if(this.currentUser.piva)  this.userPiva=this.currentUser.piva;
              if(this.currentUser.street) this.userStreet=this.currentUser.street;
              if(this.currentUser.housenumber) this.userNumber=this.currentUser.housenumber;
              if(this.currentUser.city)  this.userCity=this.currentUser.city;
              if(this.currentUser.prov)  this.userProv=this.currentUser.prov;
              if(this.currentUser.cap)  this.userCap=this.currentUser.cap;
              if(this.currentUser.country)  this.userCountry=this.currentUser.country;
            }
                
        },
    updated() {
        },
    watch: {
            commandResponse(val,oldval) {
            console.log("updated commandResponse:",val);
            if (val.pending == false && val.command == 'saveProfile') {
                    if (val.response.data!="") {
                        this.init();
                    } else {
                        this.$bvModal.msgBoxOk('Si è verificato un errore:\n' + val.response.error, {
                        title: 'Errore',
                        okVariant: 'danger',
                        centered: true
                        });
                    }
                    }
            if (val.pending == false && val.command == 'saveMarketing') {
                    if (val.response.data!="") {
                        this.init();
                    } else {
                        this.$bvModal.msgBoxOk('Si è verificato un errore:\n' + val.response.error, {
                        title: 'Errore',
                        okVariant: 'danger',
                        centered: true
                        });
                    }
                    }        
            }   
        },
    
    methods: {
        init(){
          this.editMode=false;
          this.saveUser=false;
          this.editMarketingMode=false;
          this.currentIdUser=this.$store.getters.userId;
          if(this.$route.params.event=="InstallerRegFirst")
          {
            console.log("Goto Home")
                this.$router.push({
                name: "Home"
            });
          }
          else
          {
            this.$route.params.event="";
            this.$store.dispatch('loadUserDetails', this.currentIdUser);
          }  
        },
        installerFromProfile()
        {
            this.$router.push({
                name: "UserProfile",
                params: { userId: this.$store.getters.userId, event: "InstallerRegFirst"}
            });
        },
        editProfile(){
            this.editMode=true;
            this.userName=this.currentUser.name;
            this.userSurname=this.currentUser.surname;
            this.userPhone=this.currentUser.phone;
            
            if(this.currentUser.businessname!='null')  this.userbusinessName=this.currentUser.businessname;
            if(this.currentUser.piva!='null')    this.userPiva=this.currentUser.piva;

            this.userStreet=this.currentUser.street;
            this.userNumber=this.currentUser.housenumber;
            this.userCity=this.currentUser.city;
            this.userProv=this.currentUser.prov;
            this.userCap=this.currentUser.cap;
            this.userCountry=this.currentUser.country;

        },
        editMarketing(){
            this.editMarketingMode=true;
            console.log("Marketing", this.currentUser.marketing, this.currentUser.profiling, this.currentUser.thirdparts);
            this.chk_marketing=(this.currentUser.marketing == "true");
            this.chk_profiling=(this.currentUser.profiling== "true");
            this.chk_thirdParts=(this.currentUser.thirdparts== "true");
        },
        saveProfile(){
            console.log("Salva il profilo");
            this.saveUser=true;
            var userType="basic";
            
            if(this.$route.params.event=="InstallerReg" || this.$route.params.event=="InstallerRegFirst")
            {
                userType="installer"
            }
            else
            {
                userType=this.currentUser.usertype;
            }

            console.log("USERTYPE", userType);

            if(this.userName!="" && this.userSurname!="" && this.userPhone!="" && this.userbusinessName!="" && this.userPiva!="" && this.userStreet!="" && this.userNumber!="" && this.userCity!="" && this.userProv!="" && this.userCap!="" && this.userCountry!="")
            {
              this.$store.dispatch("dbSaveProfile", {
                name: this.userName,
                surname: this.userSurname,
                businessname: this.userbusinessName,
                piva: this.userPiva,
                phone: this.userPhone,
                street: this.userStreet,
                housenumber: this.userNumber,
                city: this.userCity,
                cap: this.userCap,
                prov: this.userProv,
                country: this.userCountry,
                userType: userType
          });
            }
        },
        cancelEdit(){
            this.$route.params.event="";
            this.$router.go(-1); 
        },
        saveMarketing(){
            console.log("Salva consensi marketing");
            this.$store.dispatch("dbSaveMarketing", {
                marketing: (this.chk_marketing).toString(),
                profiling: (this.chk_profiling).toString(),
                thirdparts: (this.chk_thirdParts).toString()
          });
        },    
        cancelMarketing(){
            this.editMarketingMode=false;
            this.$route.params.event="";
        }
    }
}

</script>

<style lang="scss">

.card-profile{
    width: 100%;
}

.editIcon{
    padding-bottom:5px;
}

.editText{
    color:#009DE0;
}

#inviteUserSidebar > div.modal-dialog {
    height: 100% !important;
    position: absolute;
    right: 0px;
    width: 500px;
    margin: 0;
    padding-top: 154px;
}

#inviteUserSidebar div.modal-content {
    
    height: auto;
    min-height: 100%;
    border-radius: 0;
}

#inviteUserSidebar header.modal-header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    
}

#sidebar-invito {
    background-color: #FFFFFF !important
}

@media screen and (max-width: 767px) {
    #title-first{
        margin-left: 1rem !important;
    }
    #title-utenti{
        margin-left: 1rem !important;
    }
    #title-inviti{
        margin-left: 1rem !important;
    }
    #sezione-profilo{
        margin-bottom: 4rem !important;
    }
    #card-marketing{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
    #card-edit{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
    #card-view{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
    #check-marketing, #check-profiling, #check-thirdparts{
        font-size: 11px;
    }
}

</style>